import { IGetProdutoServicoContratoDropDownUseCase } from "../../../presentation/useCases/read/get_produto_servico_contrato_drop_down_use_case";
import { DropDown } from "../../models/dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetProdutoServicoContratoDropDownUseCase
 */

export class GetProdutoServicoContratoDropDownUseCase implements IGetProdutoServicoContratoDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getProdutoServicoContratoDropDown(idContrato: number): Promise<DropDown[]> {
    return await this.repository.getProdutoServicoContratoDropDown(idContrato);
  }
}
